// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qck1","colMin":"styles_colMin__Ck_w8"};